import styled from 'styled-components';

export const StyledLegalNoticeParagraph = styled.span`
  max-width: 810px;
  height: 28px;
  font-weight: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black};
  display: block;
`;

export const StyledRectangle = styled.div`
  width: 200%;
  height: 126px;
  margin: 60px 0 0 -32px;
  padding: 36px 32px;
  background-color: ${({ theme }) => theme.colors.gray1};
  box-sizing : border-box;
  @media only screen and (max-width: 768px){
    height: 216px;
  }
`;

export const StyledLigne = styled.div`
  width: 1px;
  height: 54px;
  margin: 0 32px 0 48px;
  background-color: ${({ theme }) => theme.colors.gray3};
  @media only screen and (max-width: 768px){
    width: 100%;
    height: 1px;
    margin: 32px 0;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  width: 750px;
  align-items: center;
  justify-content: flex-start;
  @media only screen and (max-width: 768px){
    display: block;
  }
`;

export const StyledInnercontainer = styled.div`
  width : 100%;
  display: block;
  @media only screen and (max-width: 700px){
    width : 50%;
  }
`;

export const StyledFondsCanadien = styled.a`
  width: 160px;
  height: 54px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.gray14};
  @media only screen and (max-width: 768px){
    width: 800px;
    text-align: center;
  }
`;

export const StyledIIROCAdvisor = styled.a`
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.17;
  letter-spacing: normal;
  float: none;
  color: ${({ theme }) => theme.colors.gray14};
  display: block;
`;

export const StyledCliplogo = styled.img`
  padding: 0;
  `;
